import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import AudioButton from "../../Components/Media/AudioButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import { unicodeToString } from "../../Js/Common";
import Slide from "@mui/material/Slide";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";

const style = {
  position: "absolute",
  top: "30%",
  left: "40%",
  transform: "translate(-50%, -50%)",
  width: 300,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const MoreInfo = (props) => {
  const containerRef = React.useRef(null);
  let [initialRender, setInitialRender] = useState(true);
  let [isPlaying, setIsPlaying] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={containerRef}
      >
        <Slide
          direction="up"
          in={props.visible}
          container={containerRef.current}
        >
          <Box
            sx={{
              ...style,
              backgroundColor: "primary.main",
              border: 0,
              borderRadius: 6,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                item
                sx={{
                  width: "100%",
                }}
              >
                {props.title && (
                  <>
                    <Typography
                      sx={{
                        color: "#ffffff",
                        fontWeight: "bold",
                        pb: 2,
                        width: "100%",
                        borderBottom: 1,
                        borderBottomColor: "#FFFFFF",
                      }}
                      variant="h5"
                    >
                      {props.title}
                    </Typography>
                    <Typography
                      sx={{ color: "#ffffff", fontStyle: "italic", mt: 4 }}
                    >
                      {props.subtitle ? props.subtitle : ""}
                    </Typography>
                  </>
                )}
                {props.comment && (
                  <>
                    <Typography
                      sx={{ color: "#ffffff", fontWeight: "bold", mt: 1 }}
                      variant="body2"
                    >
                      {props.comment}
                    </Typography>
                  </>
                )}
              </Grid>
              {props.list && props.list.length > 0 && (
                <Grid
                  container
                   
                  sx={{
                    justifyContent: "flex-start",
                    alignContent: "flex-start",
                    alignItems: "flex-start",
                    mt: 1
                  }}
                >
                  <List>
                    {props.list.map((val, index) => {
                      return (
                        <ListItem disablePadding>
                          <ListItemText
                            key={`${index}_list`}
                            sx={{ color: "#ffffff" }}
                            primary={`${index + 1}. ${val}`}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              )}
            </Grid>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  image: {
    width: "14rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
    },
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "25vh",
    overflow: "auto",
  },
});
export default MoreInfo;
